<template>
  <div class="user-main">
    <div class="user-page-content">
      <div class="title-section">
        <h1>信息列表</h1>
        <p>请选择需要查看的检查人信息</p>
      </div>
      <div class="loading" v-if="showLoading">
        <van-loading type="spinner" />数据加载中...
      </div>
      <div class="record" ref="list" id="list">
        <div v-for='(item, index) in recordList.list' :key='index' class="record-list-item">
          <div>
            <div>{{ item.name }}</div>
            <template v-if="item.schoolNames">
              <div v-for="(school, idx) in item.schoolNames.split(' ').filter(s => s.trim())" :key="idx" class="school-info">{{ school }}</div>
            </template>
            <div v-else class="school-info">{{ item.schoolName }}</div>
          </div>
          <div @click="onGoRecord(item)" class="record-select">查看</div>
        </div>
      </div>
      <!-- <div class="submit-btn-box">
        <van-button class="submit-btn" @click="onGoAdd">添加</van-button>
      </div> -->
      <div class="submit-btn-box">
        <van-button class="submit-btn" @click="goQuery">通过 姓名+身份证/电话/学号 查询</van-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'uniapp-user',
  data() {
    return {
      showLoading: 1,
      recordList: { list: '' },
      page: 1,
      pageType: 1,
      isLoad: false,
      openId: '',
      hospitalId: ''
    };
  },
  mounted() {
    document.title = '\u200B'; // 零宽空格字符
    const _this = this;
    this.openId = this.$route.query.openId;
    this.hospitalId = this.$route.query.hospitalId || '';
    this.pageType = this.$route.query.pageType;
    this.onGetData();
    window.addEventListener('scroll', function () {
      const scroll = document.documentElement.scrollTop || document.body.scrollTop
      const winHeight = document.body.clientHeight && document.documentElement.clientHeight
      if (_this.$refs.list != null) {
        const listHeight = _this.$refs.list.offsetHeight
        if (scroll >= listHeight - winHeight - 80) {
          _this.page++;
          _this.onGetData(_this.openId);
        }
      }
    })

  },
  methods: {
	  goQuery() {
	    this.$router.push(`/query?openId=${this.$route.query.openId}&hospitalId=${this.$route.query.hospitalId}`);
	  },
    /**
     * 获取数据
    */
    async onGetData() {
      const auth = this.$createAuth(this.$md5);
      const _this = this;
      if (!this.isLoad) {
        this.isLoad = true;
        const result = await this.$http.get(this.$url.relatedStudents, {
          openId: this.openId,
          page: this.page,
          hospitalId: this.hospitalId,
          pageSize: 30,
          auth: auth.code,
          time: auth.time
        });
        if (result.message === 'Error: Miss auth parameter.') {
          setTimeout(()=> {
            _this.showLoading = 0;
            _this.isLoad = false;
            _this.onGetData(openId);
          }, 500);
        } else {
          this.showLoading = 0;
          const list = [...this.recordList.list, ...result.data.studentList.list]
          this.recordList.list = list;
          this.isLoad = false;
        }
      }
    },
    onGoRecord(item) {
      // 选择进入默认页面
      localStorage.setItem("record_select", JSON.stringify(item));
	  let hospitalId = this.hospitalId;
      // 0626 跳转到分析页面
      if (this.pageType == 2) {
        this.$router.push(`/uniapp/analysis?openId=${this.$route.query.openId}&hospitalId=${hospitalId}&uid=${item.uid}&studentIds=${item.studentIds}`);
      }else {
        this.$router.push(`/uniapp/record?openId=${this.$route.query.openId}&hospitalId=${hospitalId}&uid=${item.uid}&studentIds=${item.studentIds}&pageType=${this.pageType}`);
      }
    },
    onGoAdd() {
	  let hospitalId = this.hospitalId;
	  if(!hospitalId){
		  hospitalId = this.recordList.list[0].hospitalId
	  }
      this.$router.push(`/uniapp/achives?openId=${this.$route.query.openId}&hospitalId=${hospitalId}&pageType=${this.pageType}`);
    }
  },
};
</script>
<style scope lang="less">
.user-main {
    background-color: white !important;
	font-family: "Arial", "思源黑体", "等线","Segoe UI", "STSong", "Heiti SC", "Noto Sans SC", sans-serif;
    min-height: 100vh;
    box-sizing: border-box;
  }
  .user-page-content {
    padding: 0 1em 0.8rem 1em;
  }
.title-section {
  text-align: center;
  padding: 0.1rem 0 0.4rem;
  background: #fff;
  margin-bottom: 0;
  h1 {
    font-size: 0.4rem;
    background: linear-gradient(90deg, #62C6A9 0%, #4DB6A1 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    margin-bottom: 0.2rem;
	margin-block-start: 0.3em;
    font-weight: bold;
  }
  p {
    font-size: 0.28rem;
    color: #666;
    margin-bottom: 0.1rem;
  }
}
.top {
  padding: 0.3rem;
  font-size: 0.32rem;
  font-weight: bold;
  border-bottom: 1px solid #dddddd;
}

.plus {
  position: absolute;
  top: 0.3rem;
  right: 0.3rem;

  img {
    width: 0.5rem;
  }
}

.record {
  padding-bottom: 1.5rem;
  background-color: #fff;
  }
  
  .record-list {
    margin-top: 0;
    padding: 0;
    background-color: #f5f5f5;
  }
  .record {
    .record-list-item:first-child {
      margin-top: 0;
    }
    .record-list-item {
	align-items: center;
    display: flex;
    justify-content: space-between;
    margin: 0 0 0.15rem 0;
    padding: 0.35rem 0.3rem;
    background: #fff;
    border-radius: 0.25rem;
    border: 1px solid #E8F6ef;
    box-shadow: 0 5px 8px #e2efe9;
    div {
        line-height: 1.8em;
        text-align: left;
        &:first-child {
          div:first-child {
            font-size: 0.34rem;
            color: #333;
            font-weight: bold;
            margin-bottom: 0.1rem;
          }
          .school-info {
            background-color: #E8F7F3;
            border-radius: 0.13rem;
            padding: 0.22em 0.1rem;
			margin: 0 0.8em 0.2em 0;
            display: inline-block;
            color: #4DB6A1;
            font-size: 0.24rem;
          }
        }
      &.record-select {
	background: linear-gradient(90deg, #62C6A9 0%, #4DB6A1 100%);
	color: #fff;
	padding: 0.12em 0.0em;
	font-size: 0.3rem;
	border-radius: 0.4rem;
	min-width: 1.3rem;
	margin-left: 1em;
        height: 1.8em;
        line-height: 1.8em;
        text-align: center;
	vertical-align: middle;
        border: none;
      }
    }
  }
}
.submit-btn-box {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 6.9rem;
  padding: 0.1rem 0.3rem 0.25rem 0.3rem;
  background: #fff;

  .submit-btn {
    width: calc(100% - 0.6rem);
    background: linear-gradient(90deg, #62C6A9 0%, #4DB6A1 100%);
    color: #fff;
    padding: 0.2rem 0 0.2rem 0;
    text-align: center;
    font-size: 0.32rem;
    border-radius: 0.4rem;
    margin: 0.2rem 0.3rem;
    border: none;
  }
}
</style>
